import React from 'react';
import { useAuth } from '../hooks/useAuth';

const UserInfo: React.FC = () => {
  const { user, getUserLevel, getGroupName, getGroupColor } = useAuth();

  if (!user) return null;

  return (
    <div className="bg-dynamic rounded-lg shadow p-4 mb-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <div 
            className="w-16 h-16 rounded-full flex items-center justify-center text-white font-bold"
            style={{ backgroundColor: getGroupColor() }}
          >
            {(user.username || (user as any).name || 'U').charAt(0).toUpperCase()}
          </div>
          <div>
            <h3 className="text-sm font-extrabold text-gray-900">{user.username || (user as any).name || 'Usuário'}</h3>
            <p className="text-sm text-gray-600">{user.email || 'Email não informado'}</p>
          </div>
        </div>
        
        <div className="text-right">
          <div 
            className="inline-flex items-center px-2.5 py-0.5 rounded-full text-sm font-medium text-white"
            style={{ backgroundColor: getGroupColor() }}
          >
            {getGroupName()}
          </div>
          <p className="text-sm font-extrabold text-gray-500 mt-1">Nível: {getUserLevel()}</p>
        </div>
      </div>
      
      {user.group && user.group.permissions && (
        <div className="mt-4 pt-4 border-t border-gray-200">
          <h4 className="text-sm font-medium text-gray-900 mb-2">Permissões:</h4>
          <div className="grid grid-cols-2 gap-2 text-xm text-gray-700">
            <div className="flex items-center space-x-2">
              <span className={`w-2 h-2 rounded-full ${user.group.permissions.can_delete_users ? 'bg-green-500' : 'bg-gray-300'}`}></span>
              <span>Deletar usuários</span>
            </div>
            <div className="flex items-center space-x-2">
              <span className={`w-2 h-2 rounded-full ${user.group.permissions.can_view_vod ? 'bg-green-500' : 'bg-gray-300'}`}></span>
              <span>Ver VOD</span>
            </div>
            <div className="flex items-center space-x-2">
              <span className={`w-2 h-2 rounded-full ${user.group.permissions.can_download ? 'bg-green-500' : 'bg-gray-300'}`}></span>
              <span>Download</span>
            </div>
            <div className="flex items-center space-x-2">
              <span className={`w-2 h-2 rounded-full ${user.group.permissions.can_create_sub_resellers ? 'bg-green-500' : 'bg-gray-300'}`}></span>
              <span>Criar sub-revendedores</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserInfo;
